import { onlineManager } from "@-/com.npmjs.tanstack__react-query";
import { useSyncExternalStore } from "react";

const subscribe = (onChange: () => void) => onlineManager.subscribe(onChange);
const getSnapshot = () => onlineManager.isOnline();
const getServerSnapshot = () => true;

/** Uses the existing native/browser connectivity subscription; never probes the auth server. */
export function useNetworkOnline(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
